module.exports = "<div class=error-list-detailed ng-cloak layout=column> <md-card flex> <rkc-table table-definition=c.tableDefinition table-content=c.transactions></rkc-table> </md-card> <div ng-if=\"c.transactions && c.transactions.length === 0\" flex layout=row> <span flex=30></span> <div layout=row flex> <div class=\"circle md-whiteframe-z2\" layout=row layout-align=\"center center\"> <h3 class=white-text>Ingen transaksjoner</h3> </div> </div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/errorList/errorListDetailed/errorListDetailed.html
 ** module id = 501
 ** module chunks = 0
 **/